import axios from 'axios';
import { API_BASE_URL } from './apiConfig';

export const buildAddressPayload = ({ userId, values, selectedCountry, selectedOption }) => ({
  userId,
  fullName: values.fullName,
  phone: values.phone,
  phoneDialCode: selectedCountry.dial,
  alternativePhone: values.alternativePhone || null,
  altPhoneDialCode: values.alternativePhone ? selectedCountry.dial : null,
  addressLine1: values.addressLine1,
  locality: values.locality || null,
  city: values.city,
  state: values.state,
  postalCode: values.postalCode,
  countryCode: selectedCountry.code,
  countryName: selectedCountry.country,
  addressType: selectedOption,
  isDefault: values.isDefault || false,
});

export const getAddressId = (responseData) => {
  const candidates = [
    responseData?.id,
    responseData?.address_id,
    responseData?.addressId,
    responseData?.data?.id,
    responseData?.data?.address_id,
    responseData?.data?.insertId,
    responseData?.address?.id,
    responseData?.address?.address_id,
    responseData?.data?.address?.id,
    responseData?.data?.address?.address_id,
  ];

  const found = candidates.find((value) => value !== undefined && value !== null && value !== '');
  return found ?? null;
};

export const setAddressAsDefaultApi = async (addressId, userId) => {
  const response = await axios.patch(`${API_BASE_URL}addresses/${addressId}/default`, { userId }, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response;
};

export const updateAddressApi = async (addressId, payload) => {
  const response = await axios.put(`${API_BASE_URL}addresses/${addressId}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response;
};
